<template>
  <div class="top-bar">
    <span class="bar-item-abs-logo">
      <img
        class="abs-logo-img"
        src="@/assets/img/ABS-Logo.png"
        alt="ABS logo"
      />
      ABS系统平台
    </span>
    <span class="bar-item"
      ><i class="icon-mail"></i>
      <a href="mailto:IB_BTrustees_ABS@cicc.com.cn"
        ><span>IB_BTrustees_ABS@cicc.com.cn</span></a
      ></span
    >
    <span class="bar-item"
      ><i class="icon-tel"></i><span>010-65051166</span></span
    >
    <span class="bar-item">
      <i class="icon-weichat"></i>
      <a-popover
        placement="bottom"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      >
        <template #content>
          <span>敬请期待</span>
        </template>
        <a href="javascript:" data-under-construction><span>关注微信</span></a>
      </a-popover>
    </span>
    <span class="bar-item">
      <i class="icon-client"></i>
      <a-popover
        placement="bottom"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      >
        <template #content>
          <span>敬请期待</span>
        </template>
        <a href="javascript:" data-under-construction
          ><span>下载交易客户端</span></a
        >
      </a-popover>
    </span>
  </div>
  <header class="site-header">
    <div class="detail-title">CICC固定收益</div>
    <div>
      <span>
        <i class="icon-production-name"></i>
        <span class="production-name">产品名称</span>
      </span>
    </div>
    <div class="special-plan-title">{{ productName }}</div>
  </header>
</template>
<script>
import { toRefs } from "vue";
export default {
  name: "DefaultHeader",
  props: {
    productName: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { productName } = toRefs(props);
  },
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.top-bar :deep() {
  height: 40px;
  color: #333333;
  background: #ffffff;
  line-height: 36px;
  & a {
    color: inherit;
    font-size: 12px;
  }
  & .bar-item-abs-logo {
    margin-left: 18%;
    margin-right: 25%;
    @media only screen and (max-width: 1335px) {
      margin-left: 8%;
      margin-right: 8%;
    }
    & .abs-logo-img {
      width: 1.8rem;
      height: 1.8rem;
      margin-right: 0.8rem;
    }
  }
  & .bar-item {
    margin: 0 20px;
    @media only screen and (max-width: 910px) {
      display: none;
    }
  }
  & .icon-mail,
  & .icon-tel,
  & .icon-weichat,
  & .icon-client {
    display: inline-block;
    width: 16px;
    margin-right: 5px;
    margin-top: 3px;
    vertical-align: middle;
  }
  & .icon-tel {
    height: 18px;
    background: url("~@/assets/img/telephone.png") no-repeat;
  }
  & .bar-item .icon-mail {
    height: 16px;
    background: url("~@/assets/img/email1.png") no-repeat;
  }
  & .bar-item .icon-weichat {
    height: 16px;
    background: url("~@/assets/img/weichat.png") no-repeat;
  }
  & .bar-item .icon-client {
    height: 16px;
    background: url("~@/assets/img/client.png") no-repeat;
  }
}

.site-header {
  height: 359px;
  background-image: url("~@/assets/img/detail-header.png");
  background-size: 100% 100%;
  padding-left: 18%;
  .detail-title {
    padding-top: 61px;
    color: #910e0e;
    font-size: 53px;
    font-family: AlimamaShuHeiTi;
    font-weight: 700;
  }
  .icon-production-name {
    padding-left: 30px;
    padding-top: 0.2%;
    background: url("~@/assets/img/production-logo.png") no-repeat;
  }
  .production-name {
    font-size: 24px;
    font-weight: 600;
    color: #333333;
  }
  .special-plan-title {
    padding-left: 2%;
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    line-height: 25px;
  }
}
</style>
